var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pulse-loader",attrs:{"aria-live":"polite","aria-busy":"true"}},[_c('div',{staticClass:"circle --top"}),_c('div',{staticClass:"circle --bottom"})])
}]

export { render, staticRenderFns }